import React, { Component } from 'react'
import { Well } from 'react-bootstrap';
import { formatToDecimal } from 'utils/Number/NumberUtils';

export default class ProductSelectedInfo extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <Well bsSize="large" bsClass="product-selected__info bg-light-secondary">
                    <div className="text-center sales-info__label">
                        <h5>Detalle del Lote</h5>
                    </div>
                    <div>
                        <span className="sales-info__label" >Proyecto: </span>
                        <span className="sales-info__value">{this.props.product.projectName}</span>
                    </div>
                    <div>
                        <span className="sales-info__label" >UV: </span>
                        <span className="sales-info__value">{this.props.product.neighborhoodUnit}</span>
                    </div>
                    <div>
                        <span className="sales-info__label" >Manzano: </span>
                        <span className="sales-info__value">{this.props.product.block}</span>
                    </div>
                    <div>
                        <span className="sales-info__label" >Lote: </span>
                        <span className="sales-info__value">{this.props.product.lotNumber}</span>
                    </div>
                    <div>
                        <span className="sales-info__label">Superficie en M2: </span>
                        <span className="sales-info__value">{formatToDecimal(this.props.product.surface)}</span>
                    </div>
                    <div hidden={this.props.product.isInversion === 'false'}>
                        <span className="sales-info__label">Precio de Venta: </span>
                        <span className="sales-info__value">{this.props.product.cashPrice}</span>
                    </div>

                    <div hidden={this.props.product.isInversion === 'true'}>
                        <span className="sales-info__label">Valor del Terreno: </span>
                        <span className="sales-info__value">{this.props.product.totalPrice}</span>
                    </div>

                    <div hidden={this.props.product.isInversion === 'true'}>
                        <span className="sales-info__label">Cuota inicial: </span>
                        <span className="sales-info__value">{this.props.product.initialQuota}</span>
                    </div>

                    <div hidden={this.props.product.isInversion === 'true'}>
                        <span className="sales-info__label">Cuota mensual: </span>
                        <span className="sales-info__value">{this.props.product.monthlyQuota}</span>
                    </div>

                    {this.props.product.status != null && <div>
                        <span className="sales-info__label">Estado: </span>
                        <span className="sales-info__value">{this.props.product.status}</span>
                    </div>
                    }
                </Well>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ProductSelectedInfo/ProductSelectedInfo.jsx